import { useFormatters } from '@/hooks/useFormatters';
import TimeElapsed from '@components/TimeElapsed';
import { MovementDataRenderer } from '@features/gateCommon';
import { formatPosition } from '@features/gateCommon/utils/formatPosition';
import { Trans } from '@lingui/macro';
import { Skeleton } from '@mui/material';
import { FC } from 'react';

interface Props {
  movementId: string | null;
  attribute:
    | 'startPosition'
    | 'requestedPosition'
    | 'requestedTimestamp'
    | 'requestedBy'
    | 'startTimestamp'
    | 'id';
}

export const MovementSummaryAttribute: FC<Props> = ({ movementId, attribute }) => {
  const { formatMetricValue, formatDateTime } = useFormatters();

  return movementId ? (
    <MovementDataRenderer
      movementId={movementId}
      render={({ movement }) => {
        if (attribute === 'startPosition' || attribute === 'requestedPosition') {
          const rawPosition = movement[attribute];
          if (rawPosition == null) return <Trans>S/D</Trans>;
          return formatPosition(rawPosition, formatMetricValue);
        }

        if (attribute === 'requestedBy') {
          return movement.requestedBy.name ?? <Trans>Sin datos</Trans>;
        }

        if (attribute === 'requestedTimestamp') {
          return formatDateTime(movement.requestedTimestamp);
        }

        if (attribute === 'id') {
          return movement.id;
        }

        if (attribute === 'startTimestamp') {
          return movement.startTimestamp ? (
            <TimeElapsed timestamp={movement.startTimestamp} />
          ) : (
            <Trans>Esperando inicio movimiento</Trans>
          );
        }

        return '';
      }}
      fallback={() => <Skeleton>Estado dummy</Skeleton>}
    />
  ) : (
    <Trans>Iniciando comunicación</Trans>
  );
};
